import {STEPPERS} from "../../utils/Constants";

export const getNextStepper = async (stepper: string) => {
    if (stepper === STEPPERS.CALENDAR) {
        return STEPPERS.PAYMENT;
    }
    return STEPPERS.PAYMENT;
}
